import { render, staticRenderFns } from "./ChangePriceList.vue?vue&type=template&id=715ec41f&scoped=true"
import script from "./ChangePriceList.vue?vue&type=script&lang=js"
export * from "./ChangePriceList.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceList.vue?vue&type=style&index=0&id=715ec41f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ec41f",
  null
  
)

export default component.exports